import { http } from './http';

/**
 * In-app OTP rail A (in-session banner) + the notification-prefs toggle.
 * Mirrors backend ShowcaseNotificationsController (/api/v1/showcase/*).
 */

export type OtpMode = 'CODE' | 'CONFIRM_ONLY';

export interface OtpNotification {
  id: string;
  mode: OtpMode;
  /** Present only for CODE; null for CONFIRM_ONLY (provider sends the code itself). */
  code: string | null;
  last4: string;
  providerName: string | null;
  merchantName: string | null;
  amountDisplay: string | null;
  expiresAt: string;
}

export interface NotificationPrefs {
  /** rail A — in-app banner. */
  inAppOtpEnabled: boolean;
  /** rail B — the OTP code is put in the Web Push notification (else a code-free nudge). */
  pushOtpEnabled: boolean;
}

export const vitrineNotificationsApi = {
  /** Pending (unviewed, unexpired) in-app OTPs, newest first. */
  list() {
    return http.get<OtpNotification[]>('/v1/showcase/notifications').then(r => r.data);
  },
  /** Mark one as seen/used so it stops appearing in the poll. */
  ack(id: string) {
    return http.post<void>(`/v1/showcase/notifications/${id}/ack`).then(() => undefined);
  },
  getPrefs() {
    return http.get<NotificationPrefs>('/v1/showcase/me/notification-prefs').then(r => r.data);
  },
  setInAppOtp(enabled: boolean) {
    return http
      .patch<NotificationPrefs>('/v1/showcase/me/notification-prefs', { inAppOtpEnabled: enabled })
      .then(r => r.data);
  },
  /** Toggle whether the Web Push carries the OTP code (rail B). Partial PATCH — leaves in-app untouched. */
  setPushOtp(enabled: boolean) {
    return http
      .patch<NotificationPrefs>('/v1/showcase/me/notification-prefs', { pushOtpEnabled: enabled })
      .then(r => r.data);
  },
};
